/**
 * Yugen Philosophy
 * Subtle fade-up on scroll. No other interaction.
 */
(function () {
  'use strict';

  if (customElements.get('yugen-philosophy')) return;

  class YugenPhilosophy extends HTMLElement {
    connectedCallback() {
      this.setupReveal();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    setupReveal() {
      const prefersReduced =
        window.matchMedia &&
        window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (prefersReduced || !('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }

      this.classList.add('is-observing');

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            this.classList.add('is-visible');
            this.observer.disconnect();
          });
        },
        { threshold: 0.18, rootMargin: '0px 0px -8% 0px' }
      );

      this.observer.observe(this);
    }
  }

  customElements.define('yugen-philosophy', YugenPhilosophy);
})();
